import HttpService from './baseHttp'

// 账单。
// 账单管理，调账
export const HttpBillManageList = (data = {}) => HttpService.post("/api/v2/cost/billCost/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询账单
export const HttpBillManage = (data = {}) => HttpService.post("/api/v2/cost/billCost/queryRow", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条账单中的费用详情
export const HttpBillManageDetail = (data = {}) => HttpService.post("/api/v2/cost/billCostDetail/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 导出明细
export const HttpGetExportDetail = (data = {}) => HttpService.post("/api/v2/cost/billCostDetail/export", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 确认账单
export const HttpConfirmBill = (data = {}) => HttpService.post("/api/v2/cost/billCost/confirmBill", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 单据操作日志
export const HttpBillManageLog = (data = {}) => HttpService.post("/api/v2/OrderLog/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 费用详情里面的基础信息查询
export const HttpQueryBillDetail = (data = {}) => HttpService.post("/api/v2/cost/billCostDetail/queryRow", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 账单详情-》仓库作业费查询
export const HttpWarehouseCost = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrderTransaction/queryByBill", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 仓储费账单单条查询
export const HttpStorageCost = (data = {}) => HttpService.post("/api/v2/cost/billingCostStorageDetailed/findByBillId", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 账单详情-》配送费
export const HttpDistribution = (data = {}) => HttpService.get("/api/v2/freightSettlement/item/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 账单详情=》调账查询
export const HttpAdjustAccountCost = (data = {}) => HttpService.post("/api/v2/cost/billingCostAdjustment/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 包材费用明细批量查询
export const HttpMaterialCostList = (data, config) => HttpService.post('/api/v2/cost/billingCostMaterialDetail/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材费用明细账单查询
export const HttpMaterialCost = (data, config) => HttpService.post('/api/v2/cost/billingCostMaterialDetail/findByBillId', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 增值服务接口
// 增值服务费用明细条件导出
export const HttpExportService = (data, config) => HttpService.post('/api/v2/cost/billingCostTransactionDetail/export', data,{ baseURL: process.env.VUE_APP_APIURL_FBB,...config  })
// 增值服务费用明细账单查询
export const HttpExtraService = (data, config) => HttpService.post('/api/v2/cost/billingCostTransactionDetail/findByBillId', data,{ baseURL: process.env.VUE_APP_APIURL_FBB })
// 增值服务费用明细批量查询
export const HttpExtraServiceList = (data, config) => HttpService.post('/api/v2/cost/billingCostTransactionDetail/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })



// 调账
export const HttpAdjustAccountList = (data = {}) => HttpService.post("/api/v2/cost/costAdjustment/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 创建调账
export const HttpSaveAdjustAccount = (data = {}) => HttpService.post("/api/v2/cost/costAdjustment/save", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 计费单列表
export const HttpGetBillingOrderList = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrder/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 计费单单条执行
export const HttpBillOrderOne = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrder/exec", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量计费
export const HttpBillbatchExec = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrder/batchExec", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//  忽略异常操作
export const HttpIgnoreAbnormal = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrder/ignoreError", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 计费单 单条查询
export const HttpGetBillingOrderOne = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrder/query_row", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储作业费
export const HttpGetWareList = (data = {}) => HttpService.post("/api/v2/cost/billingCostOrderTransaction/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//计费单 增值服务费费用明细
export const HttpBillServiceCostList = (data = {}) => HttpService.get("/api/v2/cost/billingCostTransactionDetail/findByBillOrderId", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
//计费单 包材费用明细
export const HttpBillMaterialCostList = (data = {}) => HttpService.get("/api/v2/cost/billingCostMaterialDetail/findByBillOrderId", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 包材费用明细条件导出
export const HttpExportMaterialCost = (data, config) => HttpService.post('/api/v2/cost/billingCostMaterialDetail', data,{  baseURL: process.env.VUE_APP_APIURL_FBB, ...config })

// 仓储费
export const HttpGetWarecostList = (data = {}) => HttpService.post("/api/v2/cost/billingCostStorageDetailed/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 客户费率设置
// 费率模板管理
export const HttpCusbillTemplateList = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 费率模板失效、激活
export const HttOperaTemplateOne = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/inactive", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取模板code
export const HttpGetCusbilltemplateCode = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/getTemplateCode", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 提交创建计费模板
export const HttpSaveCusTemplateCode = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费费率模板保存
export const HttpSaveTempalteStorageOne = (data = {}) => HttpService.post("/api/v2/cost/billingCostWarehouseStorage/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费率模板单条查询
export const HttpTempalteStorage = (data = {}) => HttpService.get("/api/v2/cost/billingCostWarehouseStorage/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 获取仓库作业费模板内容
export const HttpGetTemplateWarehouse = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/getTemplateItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存仓库作业模板费率
export const HttpSaveTemplateWarehouse = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/updateWarehouseOperateRate", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看单条的操作历史
export const HttpGetCusLog = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/getTemplateItemUpdateLog", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取仓储费模板费率
export const HttpGetTempalteStorage = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/getTemplateItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费率模板删除
export const HttpDelTempalteStorage = (data = {}) => HttpService.post("/api/v2/cost/billingCostWarehouseStorage/delete", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 包材项模板查询
export const HttpMaterialTemplate = (data, config) => HttpService.post('/api/v2/cost/billingCostTemplate/getTemplateItem', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材模板保存
export const HttpSaveMaterialTemplate = (data, config) => HttpService.post('/api/v2/cost/billingCostTemplate/savePackageRate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项模板保存
export const HttpSaveTransactionTemplate = (data) => HttpService.post('/api/v2/cost/billingCostTemplate/saveTransactionRate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项模板查询
export const HttpTransactionTemplate = (data) => HttpService.post('/api/v2/cost/billingCostTemplate/getTemplateItem', data, { baseURL: process.env.VUE_APP_APIURL_FBB })


export const HttpGetCusRateList = (data = {}) => HttpService.post("/api/v2/cost/costCustomerRate/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看，保存客户明细
export const HttpGetCusRateOne = (data = {}) => HttpService.post("/api/v2/cost/costCustomerRate/findCustomerInfo", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveCusRateOne = (data = {}) => HttpService.post("/api/v2/cost/costCustomerRate/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据费率类型获取费率模板
export const HttpGetCusRateTemplate = (data = {}) => HttpService.post("/api/v2/cost/billingCostTemplate/getTemplateList", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据切换客户组织获取组织列表
export const HttpGetCusOrgWareList = (data = {}) => HttpService.post("/api/v2/cost/costCustomerRate/getCustomerWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换接口
export const HttpNewGetCusOrgWareList = (data = {}) => HttpService.post("/api/v2/customerRate/getAllCustomerWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 客户费率的项目列表
export const HttpGetCusLineList = (data = {}) => HttpService.post("/api/v2/cost/costCustomerRate/getCustomerProductLine", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 账单任务列表
// 列表
export const HttpBillTaskList = (data = {}) => HttpService.get("/api/v2/billDownLoadTask/findByPage", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 单独文件的列表
export const HttpOneFileList = (data = {}) => HttpService.get("/api/v2/billDownLoadTask/fileList", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 根据承运商查找账号
export const HttpCarrierCheckAccount = (data = {}) => HttpService.get("/api/v2/carrierGroupAccount/findByCarrier", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 创建下载
export const HttpCreateDownLoad = (data = {}) => HttpService.post("/api/v2/billDownLoadTask/create", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 导入
export const HttpImportExcl = (data = {}) => HttpService.post("/api/v2/billDownLoadTask/import", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 审核
export const HttpAdjustOne = (data = {}) => HttpService.post("/api/v2/billDownLoadTask/auditFuelSurcharge", data, { baseURL: process.env.VUE_APP_APIURL_FBB });



// 账户信息配置
// 列表、查看、编辑
export const HttpBillNewsList = (data = {}) => HttpService.get("/api/v2/carrierGroupAccount/findByPage", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpQueryBillNewsOne = (data = {}) => HttpService.get("/api/v2/carrierGroupAccount/detail", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
// export const HttpSaveBillNewsOne = (data = {}) => HttpService.get("/api/v2/carrierGroupAccount/create", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveBillNewsOne = (data = {}) => HttpService.post("/api/v2/carrierGroupAccount/create", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

//子账号
//列表
export const HttpSubAccountList = (data = {}) => HttpService.get("/api/v2/billSubAccount/findByPage", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSubAccountUpdate = (data = {}) => HttpService.post("/api/v2/billSubAccount/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSubAccountDetail = (data = {}) => HttpService.get("/api/v2/billSubAccount/detail", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSubAccountDel = (data = {}) => HttpService.get("/api/v2/billSubAccount/delete", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 燃油附加费列表、编辑、增加，系统承运商服务（全部）、查看单条记录

export const HttpFuelExtraList = (data = {}) => HttpService.get("/api/v2/fuelSurchargeCarrierCfg/findByPage", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveFuelExtra = (data = {}) => HttpService.post("/api/v2/fuelSurchargeCarrierCfg/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
export const SystemDelivery = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/selectSystemDeliveryCarriers', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpFuelExtraOne = (data = {}) => HttpService.get("/api/v2/fuelSurchargeCarrierCfg/findOne", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 查看单独的燃油详情
export const HttpFuelDetailFile = (data = {}) => HttpService.get("/api/v2/billDownLoadTask/taskData", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 客户计费系数配置列表
export const HttpBillCoefficientList = (data = {}) => HttpService.post("/api/v2/customerBillRate/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 客户计费系数配置创建编辑
export const HttpBillCoefficientUpdate = (data = {}) => HttpService.post("/api/v2/customerBillRate/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 客户计费系数配置详情
export const HttpBillCoefficientDetail = (data = {}) => HttpService.get("/api/v2/customerBillRate/findOne", { params:data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 根据承运商获取账号
export const HttpGetCarrierAccount = (data = {}) => HttpService.get("/api/v2/sysAccount/findByOrgIdAndCarrier", {params:data, baseURL: process.env.VUE_APP_APIURL_SHIP });
// 获取系统承运商服务列表
export const HttpGetSysCarrierServiceAccount = (data = {}) => HttpService.get("/api/v2/sysCarrierService/findAll", {params:data, baseURL: process.env.VUE_APP_APIURL_SHIP });

// 任务下载列表批量审核
export const HttpTaskBatchApprove = (data = {}) => HttpService.post("/api/v2/billDownLoadTask/batchAuditFuelSurcharge", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 任务下载列表批量导入
export const HttpTaskBatchImport = (data = {}) => HttpService.post("/api/v2/billDownLoadTask/batchImportBillFile", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
